import * as Yup from "yup"

import messagesEn from "../src/intl/en.json"
import messagesDe from "../src/intl/de.json"

const messages = {
  en: messagesEn,
  de: messagesDe,
}

export const schema = ({ language }) => {
  const errorMessages = messages[language]

  return Yup.object().shape({
    email: Yup.string()
      .email(errorMessages["forms.errors.emailInvalid"])
      .required(errorMessages["forms.errors.emailMissing"]),
    consent: Yup.bool()
      .test(
        "consent",
        errorMessages["forms.errors.consentMissing"],
        (value) => value === true
      )
      .required(errorMessages["forms.errors.consentMissing"]),
  })
}
